import { Plus } from 'lucide-react'
import { useState } from 'react'

import { AWXCardholderStatus, AWXCardholderType } from '@ankor-io/common/types/awx'
import type { CardholderSummary } from '@ankor-io/common/types/cards'

import { Button } from '@/ui-components/Button'
import { TabContent, TabItem, Tabs } from '@/ui-components/Tabs'
import { CardholdersTable } from '@/views/Cards/CardholdersTable'
import AddNewCardholderModal from '@/views/components/Users/AddNewCardholderModal'

export const Cardholders = () => {
  const [newCardholder, setNewCardholder] = useState<CardholderSummary | null>(null)
  const [isNewCardholderModalOpen, setIsNewCardholderModalOpen] = useState(false)

  return (
    <>
      <div className="space-y-8">
        <div className="flex items-center justify-between">
          <Tabs>
            <TabItem
              current={false}
              to="/cards"
            >
              Cards
            </TabItem>
            <TabItem current={true}>Cardholders</TabItem>
          </Tabs>
          <Button
            color="primary"
            onClick={() => setIsNewCardholderModalOpen(true)}
          >
            <Plus data-slot="icon" />
            Add new Cardholder
          </Button>
        </div>
        <TabContent isActive={true}>
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-primary-900 dark:text-primary-100">Cardholders</h2>
          </div>
          <CardholdersTable newCardholder={newCardholder} />
        </TabContent>
      </div>

      <AddNewCardholderModal
        isOpen={isNewCardholderModalOpen}
        onClose={() => setIsNewCardholderModalOpen(false)}
        cardholders={[
          {
            id: '1',
            identity: {
              accountId: 'user:id:1',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
            },
            awxConnectedAccountId: 'awx:connected-account:1',
            organizationId: 'org:id:1',
            status: AWXCardholderStatus.PENDING,
            type: AWXCardholderType.INDIVIDUAL,
          },
        ]}
        onNewCardholder={setNewCardholder}
      />
    </>
  )
}

export default Cardholders
